<template>
  <a-tabs type="card">
    <a-tab-pane key="0" tab="孕产期自测">
      <tabPregnancy />
    </a-tab-pane>
    <a-tab-pane key="1" tab="BMI自测">
      <tab-bmi />
    </a-tab-pane>
    <a-tab-pane key="2" tab="吸烟危害自测">
      <tab-smoke />
    </a-tab-pane>
    <a-tab-pane key="3" tab="乙肝自测">
      <tab-hepatitis-b />
    </a-tab-pane>
     <a-tab-pane key="4" tab="健康素养测试">
      <test />
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import tabBmi from './tab-bmi'
import tabPregnancy from './tab-pregnancy'
import tabSmoke from './tab-smoke'
import tabHepatitisB from './tab-hepatitisB'
import test from '../test';

export default {
  components: {
    tabPregnancy, tabBmi, tabSmoke, tabHepatitisB,test
  }
};
</script>